/**
 * PlusIcon component.
 *
 * @component
 * @param {object} props - The component props.
 * @param {number} [props.size=16] - The size of the icon.
 * @param {string} [props.color="#07070C"] - The color of the icon.
 * @param {string} [props.className=""] - The additional CSS class name for the icon.
 * @param {any} [props.onClick] - The click event handler for the icon.
 * @returns {JSX.Element} The rendered PlusIcon component.
 */
const PlusIcon = ({ size, color, className, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "16"}
      height={size ?? "16"}
      viewBox="0 0 16 16"
      fill="none"
      className={className ?? ""}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4C8.44183 4 8.8 4.35817 8.8 4.8V7.2L11.2 7.2C11.6418 7.2 12 7.55817 12 8C12 8.44183 11.6418 8.8 11.2 8.8H8.8V11.2C8.8 11.6418 8.44183 12 8 12C7.55817 12 7.2 11.6418 7.2 11.2V8.8H4.8C4.35817 8.8 4 8.44183 4 8C4 7.55817 4.35817 7.2 4.8 7.2L7.2 7.2V4.8C7.2 4.35817 7.55817 4 8 4Z"
        fill={color ?? "#07070C"}
      />
    </svg>
  );
};

export default PlusIcon;
